import React, { Component, useState, useEffect } from "react";
import "./index.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import BasePage from "./Components/Page/BasePage";

const App = () => {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    setIsDesktop(window.innerWidth > 1000);
  }, []);

  return (
    <Router>
      <BasePage />
    </Router>
  );
};

export default App;
